$(window).on("load", function () {
	const $image = $("#lan-story .image");
	if (!$image.length) return;

	const maxImage = 5;

	const extractIndex = (src) => {
		const match = src && src.match(/image-(\d+)/);
		return match ? parseInt(match[1], 10) : 1;
	};

	const replaceIndex = (src, index) => src.replace(/(image-)(\d+)(\.[a-zA-Z]+)$/, `$1${index}$3`);

	let currentIndex = extractIndex($image.attr("src") || $image.data("src"));

	const swapImage = () => {
		currentIndex = currentIndex % maxImage + 1;
		$image.fadeOut(200, () => {
			["src", "data-src"].forEach((attr) => {
				const current = $image.attr(attr);
				if (current) $image.attr(attr, replaceIndex(current, currentIndex));
			});
			$image.fadeIn(200);
		});
	};

	setInterval(swapImage, 3000);
});